import React, { useState }  from 'react'

import { ValidatorForm } from 'react-material-ui-form-validator'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import {
    GridContainer,
    GridItem1,
    GridItem2,
    GridItem6,
    GridItem7,
    GridItem9sm12xs12,
    GridItem10,
    GridItem11,
} from '../../../business-components/Grid/Grid'

 import {
    CardGridEntradaDados,
    CardGridEntradaDadosHeaderBody,
} from '../../../business-components/Card/Card'

import {
    TextValidatorValor,
    TextValidatorMesAno,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    IconButtonEditarLeft,
    IconButtonHelp,
} from '../../../business-components/IconButton/IconButton'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import tipoFinanciamentoList from '../../../business-rules/List/tipoFinanciamentoList'

import {
    processaValoresDefaultIniciaisComparacaoFinanciamentos,
    financiamentoList,
} from './EstudoServiceComparacaoFinanciamentos'

import ConsorcioFormSimulacaoItem from '../consorcio-form/ConsorcioFormSimulacaoItem'

import DespesasFormFinanciamentoItem from '../despesas-form/DespesasFormFinanciamentoItem'

import ComparacaoFinanciamentosChart from '../estudo-chart/ComparacaoFinanciamentosChart'



const EstudoFormComparacaoFinanciamentos = ( { variaveisGlobais, values, estudo, handleChange, handleSubmit,
    setFieldValue, linhaTipoLicenca, setNaoCalcular } ) => {

    const [reexibir, setReexibir] = useState(false)

    processaValoresDefaultIniciaisComparacaoFinanciamentos(values)

    let linhaConsorcioFinanciamentoSugerido = null
    let indConsorcioFinanciamentoSugerido = null

    let linhaConsorcioFinanciamentoAlternativo = null
    let indConsorcioFinanciamentoAlternativo = null

    let linhaFinanciamentoFinanciamentoSugerido = null
    let indFinanciamentoFinanciamentoSugerido = null
    let tipoFinanciamentoSelecionadoFinanciamentoSugerido = null

    let linhaFinanciamentoFinanciamentoAlternativo = null
    let indFinanciamentoFinanciamentoAlternativo = null
    let tipoFinanciamentoSelecionadoFinanciamentoAlternativo = null

    values.objConsorcio.simulacao?.forEach( (linha, ind) => {

        if (linha.idFinanciamento === values.objComparacaoFinanciamentos.idFinanciamentoSugerido) {

            linhaConsorcioFinanciamentoSugerido = linha
            indConsorcioFinanciamentoSugerido = ind

        } else {

            if (linha.idFinanciamento === values.objComparacaoFinanciamentos.idFinanciamentoAlternativo) {

                linhaConsorcioFinanciamentoAlternativo = linha
                indConsorcioFinanciamentoAlternativo = ind
            }
        }
    })

    if (
            (!linhaConsorcioFinanciamentoSugerido && values.objComparacaoFinanciamentos.idFinanciamentoSugerido) ||
            (!linhaConsorcioFinanciamentoAlternativo && values.objComparacaoFinanciamentos.idFinanciamentoAlternativo)
    ) {

        values.financiamento?.forEach( (linha, ind) => {

            if (
                    !linhaConsorcioFinanciamentoSugerido &&
                    linha.id === values.objComparacaoFinanciamentos.idFinanciamentoSugerido
            ) {

                linhaFinanciamentoFinanciamentoSugerido = linha
                indFinanciamentoFinanciamentoSugerido = ind

                tipoFinanciamentoSelecionadoFinanciamentoSugerido =
                    pesquisaList(tipoFinanciamentoList, linha.tipoFinanciamento)

            } else {

                if (
                        !linhaConsorcioFinanciamentoAlternativo &&
                        linha.id === values.objComparacaoFinanciamentos.idFinanciamentoAlternativo
                ) {

                    linhaFinanciamentoFinanciamentoAlternativo = linha
                    indFinanciamentoFinanciamentoAlternativo = ind

                    tipoFinanciamentoSelecionadoFinanciamentoAlternativo =
                        pesquisaList(tipoFinanciamentoList, linha.tipoFinanciamento)
                }
            }
        })
    }



    return (
        <ValidatorForm 
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <GridContainer
                className="justify-center"
            >
                <GridItem9sm12xs12>
                    <CardGridEntradaDados>
                        <CardGridEntradaDadosHeaderBody
                            title={LABEL.comparacaoFinanciamentos}
                        >
                            <GridContainer>
                                <GridItem6>
                                    <GridContainer>
                                        <GridItem10>
                                            <TextFieldNumberSelect
                                                name="objComparacaoFinanciamentos.idFinanciamentoSugerido"
                                                label={LABEL.financiamentoSugerido}
                                                value={values.objComparacaoFinanciamentos.idFinanciamentoSugerido || ''}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                    setReexibir(!reexibir)
                                                }}
                                                list={financiamentoList(values,
                                                    values.objComparacaoFinanciamentos.idFinanciamentoAlternativo, false)
                                                }
                                            />
                                        </GridItem10>

                                        <GridItem2
                                            className='mt-4'
                                        >
                                            {linhaConsorcioFinanciamentoSugerido && (
                                                <CustomizedDialogsPopup
                                                    maxWidth='xl'
                                                    popupTitle={LABEL.iconButtonEditar}
                                                    tooltipTitle={LABEL.iconButtonEditar}
                                                    PopupButton={IconButtonEditarLeft}
                                                    bgDefault={true}
                                                    popupComponent={
                                                        <GridContainer
                                                            className={'justify-center'}
                                                        >
                                                            <GridItem11>
                                                                <ConsorcioFormSimulacaoItem
                                                                    variaveisGlobais={variaveisGlobais}
                                                                    values={values}
                                                                    item={linhaConsorcioFinanciamentoSugerido}
                                                                    ind={indConsorcioFinanciamentoSugerido}
                                                                    handleChange={handleChange}
                                                                    handleSubmit={handleSubmit}
                                                                    setFieldValue={setFieldValue}
                                                                    arrayHelpers={false}
                                                                    linhaTipoLicenca={linhaTipoLicenca}
                                                                    report={false}
                                                                    pagina={0}
                                                                />
                                                            </GridItem11>
                                                        </GridContainer>
                                                    }
                                                    open={setNaoCalcular}
                                                    onClose={() => {estudo.current.calculou = false}}
                                                    afterClose={setNaoCalcular}
                                                    salvarFechar={false}
                                                />
                                            )}

                                            {linhaFinanciamentoFinanciamentoSugerido && (
                                                <CustomizedDialogsPopup
                                                    maxWidth='sm'
                                                    popupTitle={LABEL.iconButtonEditar}
                                                    tooltipTitle={LABEL.iconButtonEditar}
                                                    PopupButton={IconButtonEditarLeft}
                                                    bgDefault={true}
                                                    popupComponent={
                                                        <GridContainer
                                                            className={'justify-center'}
                                                        >
                                                            <GridItem11>
                                                                <DespesasFormFinanciamentoItem
                                                                    variaveisGlobais={variaveisGlobais}
                                                                    values={values}
                                                                    handleChange={handleChange}
                                                                    handleSubmit={handleSubmit}
                                                                    setFieldValue={setFieldValue}
                                                                    arrayHelpers={false}
                                                                    linhaTipoLicenca={linhaTipoLicenca}
                                                                    tipoFinanciamentoSelecionado={
                                                                        tipoFinanciamentoSelecionadoFinanciamentoSugerido
                                                                    }
                                                                    item={linhaFinanciamentoFinanciamentoSugerido}
                                                                    ind={indFinanciamentoFinanciamentoSugerido}
                                                                    simplificado={false}
                                                                />
                                                            </GridItem11>
                                                        </GridContainer>
                                                    }
                                                    open={setNaoCalcular}
                                                    onClose={() => {estudo.current.calculou = false}}
                                                    afterClose={setNaoCalcular}
                                                    salvarFechar={false}
                                                />
                                            )}
                                        </GridItem2>
                                    </GridContainer>
                                </GridItem6>

                                <GridItem6>
                                    <GridContainer>
                                        <GridItem10>
                                            <TextFieldNumberSelect
                                                name="objComparacaoFinanciamentos.idFinanciamentoAlternativo"
                                                label={LABEL.financiamentoAlternativo}
                                                value={values.objComparacaoFinanciamentos.idFinanciamentoAlternativo || ''}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                    setReexibir(!reexibir)
                                                }}
                                                list={financiamentoList(values,
                                                    values.objComparacaoFinanciamentos.idFinanciamentoSugerido, false)
                                                }
                                            />
                                        </GridItem10>

                                        <GridItem2
                                            className='mt-4'
                                        >
                                            {linhaConsorcioFinanciamentoAlternativo && (
                                                <CustomizedDialogsPopup
                                                    maxWidth='xl'
                                                    popupTitle={LABEL.iconButtonEditar}
                                                    tooltipTitle={LABEL.iconButtonEditar}
                                                    PopupButton={IconButtonEditarLeft}
                                                    bgDefault={true}
                                                    popupComponent={
                                                        <GridContainer
                                                            className={'justify-center'}
                                                        >
                                                            <GridItem11>
                                                                <ConsorcioFormSimulacaoItem
                                                                    variaveisGlobais={variaveisGlobais}
                                                                    values={values}
                                                                    item={linhaConsorcioFinanciamentoAlternativo}
                                                                    ind={indConsorcioFinanciamentoAlternativo}
                                                                    handleChange={handleChange}
                                                                    handleSubmit={handleSubmit}
                                                                    setFieldValue={setFieldValue}
                                                                    arrayHelpers={false}
                                                                    linhaTipoLicenca={linhaTipoLicenca}
                                                                    report={false}
                                                                    pagina={0}
                                                                />
                                                            </GridItem11>
                                                        </GridContainer>
                                                    }
                                                    open={setNaoCalcular}
                                                    onClose={() => {estudo.current.calculou = false}}
                                                    afterClose={setNaoCalcular}
                                                    salvarFechar={false}
                                                />
                                            )}

                                            {linhaFinanciamentoFinanciamentoAlternativo && (
                                                <CustomizedDialogsPopup
                                                    maxWidth='sm'
                                                    popupTitle={LABEL.iconButtonEditar}
                                                    tooltipTitle={LABEL.iconButtonEditar}
                                                    PopupButton={IconButtonEditarLeft}
                                                    bgDefault={true}
                                                    popupComponent={
                                                        <GridContainer
                                                            className={'justify-center'}
                                                        >
                                                            <GridItem11>
                                                                <DespesasFormFinanciamentoItem
                                                                    variaveisGlobais={variaveisGlobais}
                                                                    values={values}
                                                                    handleChange={handleChange}
                                                                    handleSubmit={handleSubmit}
                                                                    setFieldValue={setFieldValue}
                                                                    arrayHelpers={false}
                                                                    linhaTipoLicenca={linhaTipoLicenca}
                                                                    tipoFinanciamentoSelecionado={
                                                                        tipoFinanciamentoSelecionadoFinanciamentoAlternativo
                                                                    }
                                                                    item={linhaFinanciamentoFinanciamentoAlternativo}
                                                                    ind={indFinanciamentoFinanciamentoAlternativo}
                                                                    simplificado={false}
                                                                />
                                                            </GridItem11>
                                                        </GridContainer>
                                                    }
                                                    open={setNaoCalcular}
                                                    onClose={() => {estudo.current.calculou = false}}
                                                    afterClose={setNaoCalcular}
                                                    salvarFechar={false}
                                                />
                                            )}
                                        </GridItem2>
                                    </GridContainer>
                                </GridItem6>
                            </GridContainer>

                            <GridContainer>
                                <GridItem7>
                                    <h6
                                        className='ml-1 mt-5 text-muted'
                                    >
                                        {LABEL.mesAnoPagoMesmoTempo}
                                    </h6>
                                </GridItem7>
                                <GridItem1>
                                    <TextValidatorMesAno
                                        name="objComparacaoFinanciamentos.mesAnoPagoMesmoTempo"
                                        label={LABEL.mesAno}
                                        value={values.objComparacaoFinanciamentos.mesAnoPagoMesmoTempo || ''}
                                        onChange={(e) => {
                                            handleChange(e)
                                            setReexibir(!reexibir)
                                        }}
                                    />
                                </GridItem1>
                            </GridContainer>

                            <GridContainer>
                                <GridItem7>
                                    <h6
                                        className='ml-1 mt-5 text-muted'
                                    >
                                        {LABEL.valorPagtoFinanciamentoAVista}
                                    </h6>
                                </GridItem7>
                                <GridItem2>
                                    <TextValidatorValor
                                        name="objComparacaoFinanciamentos.valorPagtoFinanciamentoAVista"
                                        label={LABEL.valorAVista}
                                        value={values.objComparacaoFinanciamentos.valorPagtoFinanciamentoAVista || ''}
                                        onChange={handleChange}
                                    />
                                </GridItem2>
                                <GridItem2>
                                    <TextValidatorMesAno
                                        name="objComparacaoFinanciamentos.mesAnoPagtoFinanciamentoAVista"
                                        label={LABEL.mesAnoPagtoFinanciamentoAVista}
                                        value={values.objComparacaoFinanciamentos.mesAnoPagtoFinanciamentoAVista || ''}
                                        onChange={(e) => {
                                            handleChange(e)
                                            setReexibir(!reexibir)
                                        }}
                                    />
                                </GridItem2>
                                <GridItem1>
                                    <IconButtonHelp
                                        helpTitle={LABEL.mesAnoPagtoFinanciamentoAVista}
                                        helpText={HELPTEXT.mesAnoPagtoFinanciamentoAVista}
                                    />
                                </GridItem1>
                            </GridContainer>

                            {!values.objComparacaoFinanciamentos.idFinanciamentoAlternativo &&
                            values.objComparacaoFinanciamentos.valorPagtoFinanciamentoAVista && (
                                <GridContainer>
                                    <GridItem7>
                                        <h6
                                            className='ml-1 mt-5 text-muted'
                                        >
                                            {LABEL.valorPagtoParcelasFinanciamentoReceitaMensal}
                                        </h6>
                                    </GridItem7>
                                    <GridItem2>
                                        <TextValidatorValor
                                            name="objComparacaoFinanciamentos.valorPagtoParcelasFinanciamentoReceitaMensal"
                                            label={LABEL.valorManterAplicado}
                                            value={values.objComparacaoFinanciamentos.valorPagtoParcelasFinanciamentoReceitaMensal || ''}
                                            onChange={handleChange}
                                        />
                                    </GridItem2>
                                </GridContainer>
                            )}
                        </CardGridEntradaDadosHeaderBody>
                    </CardGridEntradaDados>
                </GridItem9sm12xs12>
            </GridContainer>

            {values.objComparacaoFinanciamentos.idFinanciamentoSugerido &&
            //(
            //    values.objComparacaoFinanciamentos.idFinanciamentoAlternativo ||
            //    values.objComparacaoFinanciamentos.valorPagtoFinanciamentoAVista
            //) &&
            estudo.current.fluxoCaixaMensalEconomiaPerdaResumo && (reexibir || !reexibir) && (
                <ComparacaoFinanciamentosChart
                    values={values}
                    estudo={estudo}
                />
            )}
        </ValidatorForm>
    )
}

export default EstudoFormComparacaoFinanciamentos